<template>
  <div>
    <v-transition name="slide-up" :hash="'class-opponents'">
      <opponents v-if="IClassroom.opponent.name" key="classroom-opponents"></opponents>
      <div v-else class="class-podium"></div>
    </v-transition>

    <div v-if="IClassroom.classmates.length">
      <div class="seats"
           :key="'classroom-sets'">
        <span class="class-aisle" :style="{top: '7px', left: '9px'}">A</span>
        <span class="class-aisle" :style="{top: '7px', left: '49px'}">B</span>
        <span class="class-aisle" :style="{top: '7px', left: '119px'}">C</span>
        <span class="class-aisle" :style="{top: '7px', left: '159px'}">D</span>

        <transition-group name="flip-list">
          <template v-for="(user, index) in IClassroom.classmates">
            <div class="user-seat"
                 :key="'user-seat-' + user._id"
                 :title="user.user_name"
                 :class="{'is-active': user.showBubble, 'is-opponent': user.isOpponent}"
                 :style="{top: ~~(index / 4) * 50 + 30 + 'px',
               left: ~~(index % 4) * 40 + ((index % 4) > 1 ? 30:0) + 'px'}">
              <div class="figure">
                <img class="image" :src="$imagePath(user.head_image)">
              </div>
              <div class="msg-bubble"
                   :class="user.showBubble ? 'is-active' : 'is-nonactive'">
                <emoticon-bubble :icon="user.bubble"></emoticon-bubble>
              </div>
            </div>
          </template>
        </transition-group>

        <div v-for="index in 12"
             :key="'aisle-' + index"
             :style="{top: (index - 1) * 50 + 39 + 'px',
               left: '84px'}"
             class="class-aisle">
          {{ index }}
        </div>

        <span class="class-aisle" :style="{bottom: '7px', left: '9px'}">A</span>
        <span class="class-aisle" :style="{bottom: '7px', left: '49px'}">B</span>
        <span class="class-aisle" :style="{bottom: '7px', left: '119px'}">C</span>
        <span class="class-aisle" :style="{bottom: '7px', left: '159px'}">D</span>
      </div>

    </div>
    <div v-else class="box">
      <br>
      <div class="has-text-centered">
        <v-color-icon name="loader" :spin="true"></v-color-icon>
        <v-color-icon name="loader" :spin="true"></v-color-icon>
        <v-color-icon name="loader" :spin="true"></v-color-icon>
      </div>
      <p>正在进入课堂 {{ IClassroom.classmates.length }}/48，请稍候</p>
      <br>
    </div>
  </div>
</template>

<script>

import EmoticonBubble from '@/components/classroom/web/classmates/EmoticonBubble'
import IClassroom from '@/components/classroom/lib/IClassroom'
import Opponents from '@/components/classroom/web/classmates/Opponents'

export default {
  components: { Opponents, EmoticonBubble },
  name: 'Classmates',
  data () {
    return {
      IClassroom
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.class-podium {
  position relative
  margin 1rem 0 1rem
  text-align center

  &:after {
    content '讲台'
    padding 1px 20px
    border-radius 20px
    display inline-block
    position relative
    z-index 1
    background #dddddd
    font-size 14px
    font-weight bold
    color $neBg
  }

  &:before {
    content ''
    position absolute
    width 200px
    height 1px
    top 50%
    left 50%
    transform translate(-50%, -.5px)
    background #dddddd
    z-index 0
  }
}

.seats {
  position relative
  display inline-block
  width 186px
  height 650px
  user-select none
  animation fadeUpIn 1s
}

.class-index {
  display flex
  justify-content space-around
  width 180px
}

.flip-list-move {
  transition: all 1s;
}

.class-aisle {
  width 18px
  text-align center
  font-size 12px
  color white
  background #dddddd
  border-radius 50%
  transform scale(0.8)
  display inline-block
  position absolute

  &:nth-child(2) {
    margin-right 26px
  }
}

@keyframes wave {
  0%,
  100% {
    box-shadow 0 0 0 0 $link,
  }
  50% {
    box-shadow 0 0 0 12px $link
  }
}


.user-seat {
  display inline-block
  cursor pointer
  position absolute
  box-shadow 0 1px 3px rgba(0, 0, 0, .2)
  transition $transitionDefault
  border-radius 5px
  background $linkLight

  .figure {
    background white
    border-radius 50%
  }

  .image {
    opacity .3
    height 36px
    width 36px
    border 2px solid white
    transition .5s all
    display block
    border-radius 50%
    background white
  }

  &.is-active {
    animation wave 1s ease-in-out
  }

  &.is-opponent {
    background $dangerLight
  }

  &:first-child .image,
  &:nth-child(2) .image,
  &:hover .image, &.is-active .image {
    opacity 1
  }
}

.msg-bubble {
  position absolute
  user-select none
  pointer-events none
  z-index $zIndexFloat
  left 70%
  top -55%
  transform-origin -0% 95%

  &.is-active {
    animation: zoomIn .8s;
  }

  &.is-nonactive {
    transition all .3s
    transform scale(.8)
    opacity 0
  }
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform scale(.8)
  }
  65% {
    transform scale(1.5)
  }
  100% {
    opacity 1
    transform scale(1)
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1
  }
  100% {
    opacity 0
  }
}
</style>
